import { useEffect } from "react";
import { APIProvider, Map, useMap } from "@vis.gl/react-google-maps";

function Pins({ points, onClick }) {
  const map = useMap();
  useEffect(() => {
    if (!map || !window.google) return;
    const g = window.google;
    const ms = [];
    const bounds = new g.maps.LatLngBounds();
    const info = new g.maps.InfoWindow();
    (points || []).forEach((p) => {
      if (p.lat === null || p.lat === undefined || p.lon === null || p.lon === undefined) return;
      const m = new g.maps.Marker({
        position: { lat: p.lat, lng: p.lon }, map, title: p.title || "",
        icon: { path: g.maps.SymbolPath.CIRCLE, scale: 7, fillColor: p.color || "#FDD003", fillOpacity: 1, strokeColor: "#0b0b0b", strokeWeight: 1 },
      });
      if (p.title) {
        m.addListener("mouseover", () => { info.setContent(`<div style="color:#0b0b0b;font-size:12px;font-weight:600">${p.title}</div>`); info.open(map, m); });
        m.addListener("mouseout", () => info.close());
      }
      if (onClick && p.id) m.addListener("click", () => onClick(p.id));
      ms.push(m);
      bounds.extend({ lat: p.lat, lng: p.lon });
    });
    if (!bounds.isEmpty()) {
      map.fitBounds(bounds, 40);
      const l = g.maps.event.addListenerOnce(map, "idle", () => { if (map.getZoom() > 14) map.setZoom(14); });
      return () => { ms.forEach((m) => m.setMap(null)); info.close(); g.maps.event.removeListener(l); };
    }
    return () => { ms.forEach((m) => m.setMap(null)); info.close(); };
  }, [map, points, onClick]);
  return null;
}

export default function EntityMap({ points, height = 380, defaultCenter = { lat: 45.35, lng: 10.14 }, onMarkerClick }) {
  const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
  if (!apiKey) return <div className="rounded border border-border p-4 text-sm text-muted-foreground">Mappa non disponibile (chiave Google Maps mancante).</div>;
  return (
    <div className="rounded overflow-hidden border border-border" style={{ height }} data-testid="entity-map">
      <APIProvider apiKey={apiKey}>
        <Map defaultCenter={defaultCenter} defaultZoom={6} gestureHandling="greedy" mapTypeId="roadmap" style={{ width: "100%", height: "100%" }}>
          <Pins points={points} onClick={onMarkerClick} />
        </Map>
      </APIProvider>
    </div>
  );
}
